__turbopack_context__.v({
  "actionButtons": "eK0qTG_actionButtons",
  "actions": "eK0qTG_actions",
  "applyArrow": "eK0qTG_applyArrow",
  "body": "eK0qTG_body",
  "meta": "eK0qTG_meta",
  "newBadge": "eK0qTG_newBadge",
  "newBadgeDesktop": "eK0qTG_newBadgeDesktop",
  "newBadgeMobile": "eK0qTG_newBadgeMobile",
  "referButton": "eK0qTG_referButton",
  "relative": "eK0qTG_relative",
  "right": "eK0qTG_right",
  "root": "eK0qTG_root",
  "row": "eK0qTG_row",
  "title": "eK0qTG_title",
  "titleLink": "eK0qTG_titleLink",
  "titleRow": "eK0qTG_titleRow",
});
